exports.sanitizeCellValue = (value) => {
    let stringValue = String(value);
    stringValue = stringValue.replace(/[,"\\]/g, '');

    if (/[@=+\-\t\r]/.test(stringValue.charAt(0))) {
        stringValue = stringValue.replace(/[@=+\-\t\r]/g, '');
    }

    return stringValue;
};

exports.sanitizeCsvData = tableData =>
    (tableData ? tableData.map(
        row => Object.entries(row).reduce((newRow, [key, value]) => {
            newRow[key] = exports.sanitizeCellValue(value);
            return newRow;
        }, {}))
        : []);



// WEBPACK FOOTER //
// ./src/helpers/sanitizeCsvData.js